/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
// https://draftjs.org/docs/advanced-topics-managing-focus/

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from 'react-hook-form';
import { intlMessageShape } from 'constants/propTypes';
import './Editor.scss';

import { bem } from 'helpers/class-name';
import { Editor as DraftJSEditor, EditorState } from 'draft-js';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

const { block, element } = bem('hook-form-editor');

function WrappedEditor({ onChange, value, readOnly }) {
  const editorRef = useRef(null);

  return (
    <label className={element('wrapper')} onClick={() => editorRef.current?.focus()}>
      <DraftJSEditor ref={editorRef} editorState={value} onChange={onChange} readOnly={readOnly} />
    </label>
  );
}

WrappedEditor.propTypes = {
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  value: PropTypes.instanceOf(EditorState),
};

function Editor(props) {
  const { className, validators, name, readOnly } = props;
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <div className={block(className, { readOnly })}>
      <Controller
        name={name}
        rules={validators}
        render={({ field }) => <WrappedEditor {...field} />}
        readOnly={readOnly}
      />
      <ErrorMessage name={name} errors={errors} />
    </div>
  );
}

Editor.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  readOnly: PropTypes.bool,
  validators: PropTypes.shape({
    validate: PropTypes.func,
    message: PropTypes.shape(intlMessageShape),
  }),
};

export default Editor;
